import { Stack, Typography } from "@mui/material";
import type React from "react";

interface CardSectionProps {
  sectionTitle: string;
}

/**
 * A small component to create sections of a card with a title and some arbitrary children
 */
export const CardSection: React.FC<CardSectionProps> = ({
  sectionTitle,
  children,
}) => {
  return (
    <Stack spacing={1}>
      <Typography variant="body2" color={"gray"} fontWeight={400} fontSize={12}>
        {sectionTitle}
      </Typography>
      {children}
    </Stack>
  );
};
